import { LIST_GENDER } from "../LocalConst";

export class CheckIn {
  department = null;
  receptionist = null;
  issueDate = new Date();
  phoneNumber = null;
  patient = {
    phoneNumber: "",
  };
}
